import React, {
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

interface CallActiveValue {
  callActive: boolean;
  setCallActive: (active: boolean) => void;
}

const CallActiveContext = createContext<CallActiveValue>({
  callActive: false,
  setCallActive: () => undefined,
});

export const CallActiveProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [callActive, setActive] = useState(false);

  const setCallActive = useCallback((active: boolean) => {
    setActive(active);
  }, []);

  const value = useMemo(
    () => ({ callActive, setCallActive }),
    [callActive, setCallActive],
  );

  return (
    <CallActiveContext.Provider value={value}>
      {children}
    </CallActiveContext.Provider>
  );
};

export const useCallActive = () => useContext(CallActiveContext);

export default CallActiveContext;
